import React from "react";
import CardReviewSkeleton from "../card_review/cardReview";
import Skeleton from "../skeleton";

const Mobile = () => (
	<div className="container">
		<div className="child-container">
			<div className="section-title">
				<div className="title-reviews">
					<Skeleton
						width="291px"
						height="20px"
						borderRadius="8px"
					/>
					<div className="tab-reviews">
						{
							Array.from({ length: 4 }, (_value, idx) => (
								<Skeleton
									width="65px"
									height="20px"
									borderRadius="8px"
									key={idx}
								/>
							))
						}
					</div>
				</div>
			</div>

			{
				Array.from({ length: 5 }, (_index, idx) => (

					<div key={idx}>
						<CardReviewSkeleton isMobile />
						<hr style={{ height: "15px", border: "none", background: "#dfe3e8" }} />
					</div>

				))
			}

		</div>
		<style jsx>
			{`
				.container{
					padding: 0;
					width: 92%;
					max-width: 480px;
				}
				.title-reviews{
						display: flex;
						flex-direction: column;
						gap: 10px;
				}
				.tab-reviews {
						display: flex;
						gap: 8px;
						overflow-x: scroll;
				}
				hr{
						border: 1px solid #dfe3e8;
				}
		`}
		</style>
	</div>
);

export default Mobile;
